"use client";

import { useState } from "react";

interface PoapPreviewProps {
  imageUrl: string;
  name: string;
  description?: string;
  supply?: number;
  size?: "sm" | "md" | "lg";
}

const SIZES = {
  sm: "w-16 h-16",
  md: "w-32 h-32",
  lg: "w-48 h-48",
} as const;

export function PoapPreview({ imageUrl, name, description, supply, size = "md" }: PoapPreviewProps) {
  const [imgError, setImgError] = useState(false);

  return (
    <div className="flex flex-col items-center text-center">
      <div className={`${SIZES[size]} rounded-full overflow-hidden border-2 border-gray-200 relative`}>
        {imgError || !imageUrl ? (
          <div className="w-full h-full bg-purple-100 flex items-center justify-center">
            <span className="text-purple-400 text-xs font-medium">POAP</span>
          </div>
        ) : (
          /* eslint-disable-next-line @next/next/no-img-element */
          <img
            src={imageUrl}
            alt={name}
            className="w-full h-full object-cover"
            onError={() => setImgError(true)}
          />
        )}
      </div>
      <h4 className="mt-2 text-sm font-medium text-gray-900">{name}</h4>
      {description && (
        <p className="mt-1 text-xs text-gray-500 line-clamp-2 max-w-[200px]">{description}</p>
      )}
      {supply !== undefined && (
        <p className="mt-1 text-xs text-gray-400">Supply: {supply}</p>
      )}
    </div>
  );
}
